define.alias("ember-truth-helpers/helpers/is-equal", "calendar/helpers/is-equal");